import CountUp from 'react-countup';

// Smooth integer roll-up. Defaults tuned for the dashboard heroes:
// 0.7s sweep, no commas (we render Arabic-Indic separately if needed),
// preserves the previous value via CountUp's internal state so the next
// update glides from where the last one finished — no jarring resets.
export function AnimatedCounter({
  value,
  duration = 0.7,
  className,
}: {
  value: number;
  duration?: number;
  className?: string;
}) {
  return (
    <CountUp
      end={value}
      duration={duration}
      preserveValue
      separator=","
      className={className}
    />
  );
}
